webpackJsonp([1],{

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(250),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semanticKanban__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semanticKanban___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semanticKanban__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {
		SemanticKanban: __WEBPACK_IMPORTED_MODULE_1__semanticKanban___default.a
	},
	data: function data() {
		return {
			tasks: [{
				id: 3,
				subject: 'Test backlog',
				description: 'Test backlog',
				status: 'backlog',
				tags: ['help-wanted']
			}, {
				id: 1,
				subject: 'Brace yourselves',
				description: 'Winter is coming...',
				status: 'doing',
				dueDate: '2017-09-09 07:00',
				owner: 2,
				type: 'feature',
				tags: [{ title: 'request', color: 'green' }]
			}, {
				id: 2,
				subject: 'Kill Cersei',
				description: 'Shame!',
				status: 'blocked',
				dueDate: '2017-08-20 18:00',
				owner: 1,
				type: 'bug',
				tags: ['critical', 'test']
			}],
			members: [{
				id: 1,
				name: 'Danilo'
			}],
			options: {
				defaultTaskDialog: true,
				defaultConfirmDialog: true,
				defaultMemberDialog: true,
				taskExtraContent: function taskExtraContent() {
					return function () {
						var dueDate = this.task.dueDate;
						var remain = 10;
						var icon = this.task.type === 'feature' ? 'blue cubes icon' : this.task.type === 'bug' ? 'red bug icon' : '';
						return '\n\t\t\t\t\t\t\t<div class="right floated meta">\n\t\t\t\t\t\t\t\t<span>Rem. ' + remain + 'h</span>\n\t\t\t\t\t\t\t\t<i class="' + icon + '"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t' + dueDate;
					};
				}
			}
		};
	},

	methods: {
		updateTask: function updateTask(task) {
			var existingTask = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.tasks, { id: task.id });
			if (existingTask) {
				__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assign(existingTask, task);
			} else {
				task.id = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.last(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(this.tasks, ['id'])).id + 1;
				this.tasks.push(task);
			}
		},
		deleteTask: function deleteTask(task) {
			__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(this.tasks, function (t) {
				return t.id === task.id;
			});
		},
		deleteTag: function deleteTag(task, tag) {
			console.log(task, tag);
		},
		addTag: function addTag(task, tag) {
			var existingTask = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.tasks, { id: task.id });
			if (existingTask) {
				existingTask.tags.push(tag);
			}
		},
		updateMember: function updateMember(member) {
			var existingMember = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.members, { id: member.id });
			if (existingMember) {
				__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assign(existingMember, member);
			} else {
				member.id = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.last(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(this.members, ['id'])).id + 1;
				this.members.push(member);
			}
		}
	}
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_greedy_wrap__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_greedy_wrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_greedy_wrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['task', 'owners', 'extraContent', 'topContent'],
	methods: {
		openTask: function openTask(e) {
			if (e.target.className === 'ui close icon') {
				this.$emit('confirmDeleteTask', this.task);
			} else {
				this.$emit('openTask', this.task);
			}
		},
		formattedTag: function formattedTag(tag) {
			if ((typeof tag === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tag)) === 'object') {
				return tag.value;
			} else {
				return tag;
			}
		},
		getTagClass: function getTagClass(tag) {
			if ((typeof tag === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tag)) === 'object') {
				return 'ui ' + tag.color + ' label';
			} else {
				return 'ui label';
			}
		}
	},
	computed: {
		formattedSubject: function formattedSubject() {
			return this.task.subject.length > 50 ? this.task.subject.substr(0, 50) : this.task.subject;
		},
		formattedTaskDescription: function formattedTaskDescription() {
			var options = { width: 30, autoWidth: false, linebreak: ' ' };
			var description = __WEBPACK_IMPORTED_MODULE_1_greedy_wrap___default()(this.task.description || '', options);
			return !description ? '' : description.length > 100 ? description.substr(0, 100) : description;
		},
		_tags: function _tags() {
			return this.task && this.task.tags ? this.task.tags : [];
		},
		ownerName: function ownerName() {
			if (this.owners && this.owners.length) {
				var ow = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.owners, { id: this.task.owner });
				return ow && ow.name ? ow.name : this.task.owner || 'unsigned';
			} else {
				return this.task.owner || 'unsigned';
			}
		},
		_extraContent: function _extraContent() {
			var dueDate = this.task.dueDate;
			var ownerName = this.ownerName;
			return this.extraContent ? this.extraContent() : '\n\t\t\t\t<div class="right floated meta">\n\t\t\t\t\t<span>' + ownerName + '</span>\n\t\t\t\t</div>\n\t\t\t\t' + dueDate;
		},
		_topContent: function _topContent() {
			var formattedSubject = this.formattedSubject;
			return this.topContent ? this.topContent() : '\n\t\t\t\t<div class="right floated meta">\n\t\t\t\t\t<i class="ui close icon"></i>\n\t\t\t\t</div>\n\t\t\t\t' + formattedSubject;
		}
	}
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			task: {
				id: null,
				subject: null,
				description: null,
				status: null,
				owner: null,
				dueDate: null
			}
		};
	},

	methods: {
		show: function show(task) {
			if (task) {
				__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assign(this.task, task);
			} else {
				this.task.id = null;
				this.task.subject = null;
				this.task.description = null;
				this.task.status = null;
				this.task.owner = null;
				this.task.dueDate = null;
			}
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).modal('show');
		},
		hide: function hide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).modal('hide');
		},
		confirmDelete: function confirmDelete() {
			this.$emit('deleteTask', this.task);
			this.hide();
		}
	}
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			member: {
				id: null,
				name: null
			}
		};
	},

	methods: {
		show: function show(member) {
			if (member) {
				__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assign(this.member, member);
			} else {
				this.member.id = null;
				this.member.name = null;
			}
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).modal('show');
		},
		hide: function hide() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).modal('hide');
		},
		save: function save() {
			this.hide();
			this.$emit('updateMember', this.member);
		}
	}
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_greedy_wrap__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_greedy_wrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_greedy_wrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['task', 'extraContent', 'topContent'],
	methods: {
		getCardClass: function getCardClass() {
			return this.task.status === 'doing' ? 'ui yellow card' : this.task.status === 'blocked' ? 'ui red card' : this.task.status === 'done' ? 'ui green card' : 'ui grey card';
		},
		openTask: function openTask(e) {
			if (e.target.className === 'ui close icon') {
				this.$emit('confirmDeleteTask', this.task);
			} else {
				this.$emit('openTask', this.task);
			}
		},
		formattedTag: function formattedTag(tag) {
			if ((typeof tag === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tag)) === 'object') {
				return tag.value;
			} else {
				return tag;
			}
		},
		getTagClass: function getTagClass(tag) {
			if ((typeof tag === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tag)) === 'object') {
				return 'ui ' + tag.color + ' label';
			} else {
				return 'ui label';
			}
		}
	},
	computed: {
		formattedSubject: function formattedSubject() {
			return this.task.subject.length > 50 ? this.task.subject.substr(0, 50) : this.task.subject;
		},
		formattedTaskDescription: function formattedTaskDescription() {
			var options = { width: 30, autoWidth: false, linebreak: ' ' };
			var description = __WEBPACK_IMPORTED_MODULE_1_greedy_wrap___default()(this.task.description || '', options);
			return !description ? '' : description.length > 100 ? description.substr(0, 100) : description;
		},
		_tags: function _tags() {
			return this.task && this.task.tags ? this.task.tags : [];
		},
		_extraContent: function _extraContent() {
			var dueDate = this.task.dueDate;
			var remain = this.task.dueDate ? Math.round(__WEBPACK_IMPORTED_MODULE_2_moment___default()().diff(this.task.dueDate) / 1000 / 60 / 60) * -1 : '';
			return this.extraContent ? this.extraContent() : '\n\t\t\t\t<div class="right floated meta">\n\t\t\t\t\t<span>Rem. ' + remain + 'h</span>\n\t\t\t\t</div>\n\t\t\t\t' + dueDate;
		},
		_topContent: function _topContent() {
			var formattedSubject = this.formattedSubject;
			return this.topContent ? this.topContent() : '\n\t\t\t\t<div class="right floated meta">\n\t\t\t\t\t<i class="ui close icon"></i>\n\t\t\t\t</div>\n\t\t\t\t' + formattedSubject;
		}
	}
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fengyuanchen_datepicker__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fengyuanchen_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fengyuanchen_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fengyuanchen_datepicker_dist_datepicker_css__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fengyuanchen_datepicker_dist_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fengyuanchen_datepicker_dist_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_color__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_color__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		'chrome-picker': __WEBPACK_IMPORTED_MODULE_6_vue_color__["Compact"]
	},
	props: ['owners'],
	data: function data() {
		return {
			task: {
				id: null,
				subject: null,
				description: null,
				status: 'backlog',
				owner: null,
				dueDate: null,
				tags: []
			},
			newTag: false,
			palette: ['#DB2828', '#F2711C', '#FBBD08', '#B5CC18', '#21BA45', '#00B5AD', '#2185D0', '#A333C8', '#E03997', '#A5673F', '#1B1C1D'],
			semanticColors: ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'purple', 'pink', 'brown', 'black'],
			colors: {
				hex: '#21BA45',
				hsl: {
					h: 134,
					s: 0.7,
					l: 0.43,
					a: 1
				},
				hsv: {
					h: 134,
					s: 0.82,
					v: 0.73,
					a: 1
				},
				rgba: {
					r: 33,
					g: 186,
					b: 69,
					a: 1
				},
				a: 1
			}
		};
	},

	computed: {
		_tags: function _tags() {
			return this.task && this.task.tags ? this.task.tags : [];
		}
	},
	methods: {
		show: function show(task) {
			this.newTag = false;
			if (task) {
				__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.assign(this.task, task);
			} else {
				this.task.id = null;
				this.task.subject = null;
				this.task.description = null;
				this.task.status = 'backlog';
				this.task.owner = null;
				this.task.dueDate = null;
				this.task.tags = [];
			}
			__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).modal('show');
		},
		hide: function hide() {
			__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).modal('hide');
		},
		saveTask: function saveTask() {
			this.$emit('updateTask', this.task);
			this.hide();
		},
		formattedTag: function formattedTag(tag) {
			if ((typeof tag === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tag)) === 'object') {
				return tag.value;
			} else {
				return tag;
			}
		},
		getTagClass: function getTagClass(tag) {
			if ((typeof tag === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tag)) === 'object') {
				return 'ui ' + tag.color + ' label';
			} else {
				return 'ui label';
			}
		},
		addNewTag: function addNewTag() {
			this.newTag = true;
		},
		saveNewTag: function saveNewTag(e) {
			this.newTag = false;
			var pickedColorIndex = this.$refs.colorpicker.pick ? this.palette.indexOf(this.$refs.colorpicker.pick) : -1;
			var color = pickedColorIndex > -1 ? this.semanticColors[pickedColorIndex] : '';
			var value = e.target.value;
			if (!this.task.id) {
				this.task.tags.push({ value: value, color: color });
			}
			this.$emit('addTag', this.task, { value: value, color: color });
		},
		cancelNewTag: function cancelNewTag() {
			this.newTag = false;
		},
		deleteTag: function deleteTag(tag) {
			this.$emit('deleteTag', this.task, tag);
		}
	},
	mounted: function mounted() {
		var vm = this;
		__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('#taskDueDate').datepicker({
			format: 'mm/dd/yyyy hh:mm',
			autoHide: true
		}).on('pick.datepicker', function (e) {
			vm.task[e.currentTarget.name] = __WEBPACK_IMPORTED_MODULE_3_moment___default()(e.date).format('MM/DD/YYYY hh:mm');
		});
	}
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dragula__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dragula___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dragula__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_css_semantic_min__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_css_semantic_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_css_semantic_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_css_semantic_min_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_css_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_css_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_backlogCard_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_backlogCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_backlogCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_taskCard_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_taskCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_taskCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_taskDialog_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_taskDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_taskDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_confirmDialog_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_confirmDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_confirmDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_memberDialog_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_memberDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_memberDialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		BacklogCard: __WEBPACK_IMPORTED_MODULE_5__components_backlogCard_vue___default.a,
		TaskCard: __WEBPACK_IMPORTED_MODULE_6__components_taskCard_vue___default.a,
		TaskDialog: __WEBPACK_IMPORTED_MODULE_7__components_taskDialog_vue___default.a,
		ConfirmDialog: __WEBPACK_IMPORTED_MODULE_8__components_confirmDialog_vue___default.a,
		MemberDialog: __WEBPACK_IMPORTED_MODULE_9__components_memberDialog_vue___default.a
	},
	props: {
		tasks: {
			type: Array,
			required: true
		},
		members: {
			type: Array,
			required: true
		},
		options: {
			type: Object,
			required: false
		}
	},
	computed: {
		_members: function _members() {
			if (this.members && this.members.length > 0) {
				return this.members.concat({
					id: 'unsigned',
					name: 'unsigned',
					doing: [],
					blocked: [],
					done: []
				});
			} else {
				return [{
					id: 'unsigned',
					name: 'unsigned',
					doing: [],
					blocked: [],
					done: []
				}];
			}
		},
		_backlog: function _backlog() {
			return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.tasks, { status: 'backlog' });
		},
		_team: function _team() {
			var tasks = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.tasks, function (task) {
				return task.status !== 'backlog' && task.status !== 'archived';
			});
			if (tasks && tasks.length) {
				var team = [];
				var members = this._members.map(function (m) {
					m.doing = [];
					m.blocked = [];
					m.done = [];
					return m;
				});

				for (var i = 0; i < tasks.length; i++) {
					var task = tasks[i];
					var member = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(members, { id: task.owner });
					if (!member) {
						member = members[0];
					}

					if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(team, { id: member.id })) {
						team.push(member);
					}

					if (task.status === 'doing') {
						if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(member.doing, { id: task.id })) {
							member.doing.push(task);
						}
					} else if (task.status === 'blocked') {
						if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(member.blocked, { id: task.id })) {
							member.blocked.push(task);
						}
					} else if (task.status === 'done') {
						if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(member.done, { id: task.id })) {
							member.done.push(task);
						}
					}
				}
				return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(team, ['name']);
			} else {
				return this._members;
			}
		},
		_columnLabels: function _columnLabels() {
			if (this.options && this.options.columnLabels) {
				return this.options.columnLabels;
			} else {
				return ['Backlog', 'Team', 'Doing', 'Blocked', 'Done'];
			}
		},
		_backlogLabel: function _backlogLabel() {
			return this._columnLabels[0];
		},
		_teamLabel: function _teamLabel() {
			return this._columnLabels[1];
		},
		_doingLabel: function _doingLabel() {
			return this._columnLabels[2];
		},
		_blockedLabel: function _blockedLabel() {
			return this._columnLabels[3];
		},
		_doneLabel: function _doneLabel() {
			return this._columnLabels[4];
		},
		_newTaskHint: function _newTaskHint() {
			return this.options && this.options.newTaskHint ? this.options.newTaskHint : 'New Task';
		},
		_newMemberHint: function _newMemberHint() {
			return this.options && this.options.newMemberHint ? this.options.newMemberHint : 'New Member';
		},
		_backlogExtraContent: function _backlogExtraContent() {
			return this.options && this.options.backlogExtraContent ? this.options.backlogExtraContent() : null;
		},
		_backlogTopContent: function _backlogTopContent() {
			return this.options && this.options.backlogTopContent ? this.options.backlogTopContent() : null;
		},
		_taskExtraContent: function _taskExtraContent() {
			return this.options && this.options.taskExtraContent ? this.options.taskExtraContent() : null;
		},
		_taskTopContent: function _taskTopContent() {
			return this.options && this.options.taskTopContent ? this.options.taskTopContent() : null;
		}
	},
	methods: {
		getImage: function getImage(avatar) {
			return avatar || './assets/unsigned.png';
		},
		openTask: function openTask(task) {
			if (!this.options || this.options.defaultTaskDialog) {
				this.$refs.dialog.show(task);
			} else {
				if (task) {
					this.$emit('openTask', task);
				} else {
					this.$emit('newTask');
				}
			}
		},
		confirmDeleteTask: function confirmDeleteTask(task) {
			if (!this.options || this.options.defaultConfirmDialog) {
				this.$refs.confirm.show(task);
			} else {
				this.$emit('confirmDeleteTask', task);
			}
		},
		deleteTask: function deleteTask(task) {
			this.$emit('deleteTask', task);
		},
		getTaskById: function getTaskById(id) {
			var backlogTask = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this._backlog, { id: id });
			if (backlogTask) {
				return backlogTask;
			}

			return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.tasks, { id: id });
		},
		updateTask: function updateTask(task) {
			this.$emit('updateTask', task);
		},
		addTag: function addTag(task, tag) {
			this.$emit('addTag', task, tag);
		},
		deleteTag: function deleteTag(task, tag) {
			this.$emit('deleteTag', task, tag);
		},
		newMember: function newMember() {
			if (!this.options || this.options.defaultMemberDialog) {
				this.$refs.memberDialog.show();
			} else {
				this.$emit('newMember');
			}
		},
		updateMember: function updateMember(member) {
			this.$emit('updateMember', member);
		},
		configDragula: function configDragula() {
			var self = this;
			/*
   	Disable swipe-history-navigation
   	https://superuser.com/questions/840102/how-do-you-disable-swipe-history-navigation
   	Go to chrome://flags/#overscroll-history-navigation
   	Disable the Overscroll history navigation experiment:
   */
			var drake = __WEBPACK_IMPORTED_MODULE_2_dragula___default()({
				isContainer: function isContainer(el) {
					return el.classList.contains('todo') || el.classList.contains('doing') || el.classList.contains('blocked') || el.classList.contains('done');
				},
				moves: function moves(el, target, source, sibling) {
					var owner = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(target).attr('owner');
					var status = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(target).attr('class').split(' ').reverse()[0];

					var sourceOwner = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(source).attr('owner');
					var sourceStatus = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(source).attr('class').split(' ').reverse()[0];

					if (owner !== sourceOwner || status !== sourceStatus) {
						return true;
					} else {
						return false;
					}
				},
				accepts: function accepts(el, target, source, sibling) {
					var owner = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(target).attr('owner');
					var status = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(target).attr('class').split(' ').reverse()[0];

					var sourceOwner = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(source).attr('owner');
					var sourceStatus = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(source).attr('class').split(' ').reverse()[0];

					if (owner !== sourceOwner || status !== sourceStatus) {
						return true;
					} else {
						return false;
					}
				}
			});

			drake.on('drop', function (el, target, source, sibling) {
				var id = Number(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).attr('id'));
				var owner = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(target).attr('owner');
				var status = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(target).attr('class').split(' ').reverse()[0];

				var sourceOwner = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(source).attr('owner');
				var sourceStatus = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(source).attr('class').split(' ').reverse()[0];

				if (owner !== sourceOwner || status !== sourceStatus) {
					var task = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(self.getTaskById(id));
					task.status = status;
					task.owner = owner;

					self.$emit('updateTask', task);
					return true;
				} else {
					return false;
				}
			});
		}
	},
	mounted: function mounted() {
		this.configDragula();
	}
});

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 44,
	"./af.js": 44,
	"./ar": 51,
	"./ar-dz": 45,
	"./ar-dz.js": 45,
	"./ar-kw": 46,
	"./ar-kw.js": 46,
	"./ar-ly": 47,
	"./ar-ly.js": 47,
	"./ar-ma": 48,
	"./ar-ma.js": 48,
	"./ar-sa": 49,
	"./ar-sa.js": 49,
	"./ar-tn": 50,
	"./ar-tn.js": 50,
	"./ar.js": 51,
	"./az": 52,
	"./az.js": 52,
	"./be": 53,
	"./be.js": 53,
	"./bg": 54,
	"./bg.js": 54,
	"./bm": 55,
	"./bm.js": 55,
	"./bn": 56,
	"./bn.js": 56,
	"./bo": 57,
	"./bo.js": 57,
	"./br": 58,
	"./br.js": 58,
	"./bs": 59,
	"./bs.js": 59,
	"./ca": 60,
	"./ca.js": 60,
	"./cs": 61,
	"./cs.js": 61,
	"./cv": 62,
	"./cv.js": 62,
	"./cy": 63,
	"./cy.js": 63,
	"./da": 64,
	"./da.js": 64,
	"./de": 67,
	"./de-at": 65,
	"./de-at.js": 65,
	"./de-ch": 66,
	"./de-ch.js": 66,
	"./de.js": 67,
	"./dv": 68,
	"./dv.js": 68,
	"./el": 69,
	"./el.js": 69,
	"./en-SG": 70,
	"./en-SG.js": 70,
	"./en-au": 71,
	"./en-au.js": 71,
	"./en-ca": 72,
	"./en-ca.js": 72,
	"./en-gb": 73,
	"./en-gb.js": 73,
	"./en-ie": 74,
	"./en-ie.js": 74,
	"./en-il": 75,
	"./en-il.js": 75,
	"./en-nz": 76,
	"./en-nz.js": 76,
	"./eo": 77,
	"./eo.js": 77,
	"./es": 80,
	"./es-do": 78,
	"./es-do.js": 78,
	"./es-us": 79,
	"./es-us.js": 79,
	"./es.js": 80,
	"./et": 81,
	"./et.js": 81,
	"./eu": 82,
	"./eu.js": 82,
	"./fa": 83,
	"./fa.js": 83,
	"./fi": 84,
	"./fi.js": 84,
	"./fo": 85,
	"./fo.js": 85,
	"./fr": 88,
	"./fr-ca": 86,
	"./fr-ca.js": 86,
	"./fr-ch": 87,
	"./fr-ch.js": 87,
	"./fr.js": 88,
	"./fy": 89,
	"./fy.js": 89,
	"./ga": 90,
	"./ga.js": 90,
	"./gd": 91,
	"./gd.js": 91,
	"./gl": 92,
	"./gl.js": 92,
	"./gom-latn": 93,
	"./gom-latn.js": 93,
	"./gu": 94,
	"./gu.js": 94,
	"./he": 95,
	"./he.js": 95,
	"./hi": 96,
	"./hi.js": 96,
	"./hr": 97,
	"./hr.js": 97,
	"./hu": 98,
	"./hu.js": 98,
	"./hy-am": 99,
	"./hy-am.js": 99,
	"./id": 100,
	"./id.js": 100,
	"./is": 101,
	"./is.js": 101,
	"./it": 103,
	"./it-ch": 102,
	"./it-ch.js": 102,
	"./it.js": 103,
	"./ja": 104,
	"./ja.js": 104,
	"./jv": 105,
	"./jv.js": 105,
	"./ka": 106,
	"./ka.js": 106,
	"./kk": 107,
	"./kk.js": 107,
	"./km": 108,
	"./km.js": 108,
	"./kn": 109,
	"./kn.js": 109,
	"./ko": 110,
	"./ko.js": 110,
	"./ku": 111,
	"./ku.js": 111,
	"./ky": 112,
	"./ky.js": 112,
	"./lb": 113,
	"./lb.js": 113,
	"./lo": 114,
	"./lo.js": 114,
	"./lt": 115,
	"./lt.js": 115,
	"./lv": 116,
	"./lv.js": 116,
	"./me": 117,
	"./me.js": 117,
	"./mi": 118,
	"./mi.js": 118,
	"./mk": 119,
	"./mk.js": 119,
	"./ml": 120,
	"./ml.js": 120,
	"./mn": 121,
	"./mn.js": 121,
	"./mr": 122,
	"./mr.js": 122,
	"./ms": 124,
	"./ms-my": 123,
	"./ms-my.js": 123,
	"./ms.js": 124,
	"./mt": 125,
	"./mt.js": 125,
	"./my": 126,
	"./my.js": 126,
	"./nb": 127,
	"./nb.js": 127,
	"./ne": 128,
	"./ne.js": 128,
	"./nl": 130,
	"./nl-be": 129,
	"./nl-be.js": 129,
	"./nl.js": 130,
	"./nn": 131,
	"./nn.js": 131,
	"./pa-in": 132,
	"./pa-in.js": 132,
	"./pl": 133,
	"./pl.js": 133,
	"./pt": 135,
	"./pt-br": 134,
	"./pt-br.js": 134,
	"./pt.js": 135,
	"./ro": 136,
	"./ro.js": 136,
	"./ru": 137,
	"./ru.js": 137,
	"./sd": 138,
	"./sd.js": 138,
	"./se": 139,
	"./se.js": 139,
	"./si": 140,
	"./si.js": 140,
	"./sk": 141,
	"./sk.js": 141,
	"./sl": 142,
	"./sl.js": 142,
	"./sq": 143,
	"./sq.js": 143,
	"./sr": 145,
	"./sr-cyrl": 144,
	"./sr-cyrl.js": 144,
	"./sr.js": 145,
	"./ss": 146,
	"./ss.js": 146,
	"./sv": 147,
	"./sv.js": 147,
	"./sw": 148,
	"./sw.js": 148,
	"./ta": 149,
	"./ta.js": 149,
	"./te": 150,
	"./te.js": 150,
	"./tet": 151,
	"./tet.js": 151,
	"./tg": 152,
	"./tg.js": 152,
	"./th": 153,
	"./th.js": 153,
	"./tl-ph": 154,
	"./tl-ph.js": 154,
	"./tlh": 155,
	"./tlh.js": 155,
	"./tr": 156,
	"./tr.js": 156,
	"./tzl": 157,
	"./tzl.js": 157,
	"./tzm": 159,
	"./tzm-latn": 158,
	"./tzm-latn.js": 158,
	"./tzm.js": 159,
	"./ug-cn": 160,
	"./ug-cn.js": 160,
	"./uk": 161,
	"./uk.js": 161,
	"./ur": 162,
	"./ur.js": 162,
	"./uz": 164,
	"./uz-latn": 163,
	"./uz-latn.js": 163,
	"./uz.js": 164,
	"./vi": 165,
	"./vi.js": 165,
	"./x-pseudo": 166,
	"./x-pseudo.js": 166,
	"./yo": 167,
	"./yo.js": 167,
	"./zh-cn": 168,
	"./zh-cn.js": 168,
	"./zh-hk": 169,
	"./zh-hk.js": 169,
	"./zh-tw": 170,
	"./zh-tw.js": 170
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 228;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/unsigned.574bdd9.png";

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(245),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(248),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(244),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(247),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(246),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 244:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getCardClass(),
    attrs: {
      "id": _vm.task.id
    },
    on: {
      "click": _vm.openTask
    }
  }, [_c('a', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm._topContent)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.formattedTaskDescription) + "\n\t")]), _vm._v(" "), (_vm._tags.length > 0) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm._tags), function(tag) {
    return _c('div', {
      class: _vm.getTagClass(tag)
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm.formattedTag(tag)) + "\n\t\t")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "extra content",
    domProps: {
      "innerHTML": _vm._s(_vm._extraContent)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui blue card",
    attrs: {
      "id": _vm.task.id
    },
    on: {
      "click": _vm.openTask
    }
  }, [_c('a', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm._topContent)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.formattedTaskDescription) + "\n\t")]), _vm._v(" "), (_vm._tags.length > 0) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm._tags), function(tag) {
    return _c('div', {
      class: _vm.getTagClass(tag)
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm.formattedTag(tag)) + "\n\t\t")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "extra content",
    domProps: {
      "innerHTML": _vm._s(_vm._extraContent)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic segment"
  }, [_c('div', {
    staticClass: "ui sixteen wide celled grid"
  }, [_c('div', {
    staticClass: "ui three wide column"
  }, [_c('div', {
    staticClass: "ui blue ribbon label"
  }, [_vm._v(_vm._s(_vm._backlogLabel))]), _vm._v(" "), _c('div', {
    staticClass: "ui circular right floated icon button",
    attrs: {
      "title": _vm._newTaskHint
    },
    on: {
      "click": function($event) {
        return _vm.openTask(null)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "todo"
  }, [_c('br'), _vm._v(" "), _vm._l((_vm._backlog), function(t) {
    return _c('backlog-card', {
      key: t.id,
      attrs: {
        "task": t,
        "owners": _vm.members,
        "extra-content": _vm._backlogExtraContent,
        "top-content": _vm._backlogTopContent
      },
      on: {
        "openTask": _vm.openTask,
        "confirmDeleteTask": _vm.confirmDeleteTask
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ui thirteen wide column"
  }, [_c('div', {
    staticClass: "ui sixteen column celled grid"
  }, [_c('div', {
    staticClass: "equal height row"
  }, [_c('div', {
    staticClass: "three wide center aligned column"
  }, [_c('div', {
    staticClass: "ui basic label"
  }, [_c('i', {
    staticClass: "users icon"
  }), _vm._v(" " + _vm._s(_vm._teamLabel) + "\n\t\t\t\t\t\t\t"), _c('a', {
    staticClass: "detail",
    attrs: {
      "title": _vm._newMemberHint
    },
    on: {
      "click": _vm.newMember
    }
  }, [_c('i', {
    staticClass: "teal plus icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "five wide column"
  }, [_c('div', {
    staticClass: "ui yellow ribbon label"
  }, [_vm._v(_vm._s(_vm._doingLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui red ribbon label"
  }, [_vm._v(_vm._s(_vm._blockedLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui green ribbon label"
  }, [_vm._v(_vm._s(_vm._doneLabel))])])]), _vm._v(" "), _vm._l((_vm._team), function(member) {
    return _c('div', {
      key: member.id,
      staticClass: "equal height row"
    }, [_c('div', {
      staticClass: "three wide column"
    }, [(member.avatar === undefined) ? _c('img', {
      staticClass: "ui avatar image",
      attrs: {
        "src": __webpack_require__(236)
      }
    }) : _vm._e(), _vm._v(" "), (member.avatar !== undefined) ? _c('img', {
      staticClass: "ui avatar image",
      attrs: {
        "src": _vm.getImage(member.avatar)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ui basic left pointing label"
    }, [_vm._v(_vm._s(member.name))])]), _vm._v(" "), _c('div', {
      staticClass: "five wide column doing",
      attrs: {
        "owner": member.id
      }
    }, _vm._l((member.doing), function(t) {
      return _c('task-card', {
        key: t.id,
        attrs: {
          "task": t,
          "extra-content": _vm._taskExtraContent,
          "top-content": _vm._taskTopContent
        },
        on: {
          "openTask": _vm.openTask,
          "confirmDeleteTask": _vm.confirmDeleteTask
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "four wide column blocked",
      attrs: {
        "owner": member.id
      }
    }, _vm._l((member.blocked), function(t) {
      return _c('task-card', {
        key: t.id,
        attrs: {
          "task": t,
          "extra-content": _vm._taskExtraContent,
          "top-content": _vm._taskTopContent
        },
        on: {
          "openTask": _vm.openTask,
          "confirmDeleteTask": _vm.confirmDeleteTask
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "four wide column done",
      attrs: {
        "owner": member.id
      }
    }, _vm._l((member.done), function(t) {
      return _c('task-card', {
        key: t.id,
        attrs: {
          "task": t,
          "extra-content": _vm._taskExtraContent,
          "top-content": _vm._taskTopContent
        },
        on: {
          "openTask": _vm.openTask,
          "confirmDeleteTask": _vm.confirmDeleteTask
        }
      })
    }), 1)])
  })], 2)])]), _vm._v(" "), _c('task-dialog', {
    ref: "dialog",
    attrs: {
      "owners": _vm.members
    },
    on: {
      "updateTask": _vm.updateTask,
      "addTag": _vm.addTag,
      "deleteTag": _vm.deleteTag
    }
  }), _vm._v(" "), _c('confirm-dialog', {
    ref: "confirm",
    on: {
      "deleteTask": _vm.deleteTask
    }
  }), _vm._v(" "), _c('member-dialog', {
    ref: "memberDialog",
    on: {
      "updateMember": _vm.updateMember
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v("Subject")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.subject),
      expression: "task.subject"
    }],
    attrs: {
      "type": "text",
      "name": "subject"
    },
    domProps: {
      "value": (_vm.task.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "subject", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.description),
      expression: "task.description"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.task.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "seven wide required field"
  }, [_c('label', [_vm._v("Owner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.owner),
      expression: "task.owner"
    }],
    staticClass: "ui fluid search dropdown",
    attrs: {
      "name": "owner"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "owner", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.owners), function(ow) {
    return _c('option', {
      domProps: {
        "value": ow.id
      }
    }, [_vm._v(_vm._s(ow.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v("Due Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.dueDate),
      expression: "task.dueDate"
    }],
    attrs: {
      "id": "taskDueDate",
      "name": "dueDate",
      "type": "text",
      "data-toggle": "datepicker"
    },
    domProps: {
      "value": (_vm.task.dueDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "dueDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.status),
      expression: "task.status"
    }],
    staticClass: "ui fluid search dropdown",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "backlog"
    }
  }, [_vm._v("Backlog")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "doing"
    }
  }, [_vm._v("Doing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "blocked"
    }
  }, [_vm._v("Blocked")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "done"
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "archived"
    }
  }, [_vm._v("Archived")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, _vm._l((_vm._tags), function(tag) {
    return _c('div', {
      class: _vm.getTagClass(tag)
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.formattedTag(tag)) + "\n\t\t\t\t\t"), _c('i', {
      staticClass: "close icon",
      on: {
        "click": function($event) {
          return _vm.deleteTag(tag)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [(_vm.newTag) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui mini input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "newTag"
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveNewTag($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelNewTag($event)
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newTag) ? _c('div', {
    staticClass: "field"
  }, [_c('chrome-picker', {
    ref: "colorpicker",
    attrs: {
      "palette": _vm.palette
    },
    model: {
      value: (_vm.colors),
      callback: function($$v) {
        _vm.colors = $$v
      },
      expression: "colors"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.newTag) ? _c('a', {
    staticClass: "ui left pointing basic label",
    on: {
      "click": _vm.addNewTag
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" New tag\n\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.saveTask()
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Would you like to delete the task \"" + _vm._s(_vm.task.id) + " - " + _vm._s(_vm.task.subject) + "\"?")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui red basic cancel inverted button",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n\t\t\tNo\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n\t\t\tYes\n\t\t")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("\n\t\tDelete Task\n\t")])
}]}

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui mini modal"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.name),
      expression: "member.name"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.member.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.member, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('semantic-kanban', {
    attrs: {
      "tasks": _vm.tasks,
      "members": _vm.members,
      "options": _vm.options
    },
    on: {
      "updateTask": _vm.updateTask,
      "deleteTask": _vm.deleteTask,
      "addTag": _vm.addTag,
      "deleteTag": _vm.deleteTag,
      "updateMember": _vm.updateMember
    }
  })
},staticRenderFns: []}

/***/ })

},[178]);


// WEBPACK FOOTER //
// static/js/app.c632bc1d759be875d95a.js